import React from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link } from "react-router-dom";
import { BsArrowBarUp } from "react-icons/bs";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { IoMdNotificationsOutline } from "react-icons/io";
import { MdPerson } from "react-icons/md";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../hooks/useTheme";
import { FaUser } from "react-icons/fa";
import { MdLogout } from "react-icons/md";
import { logger } from "../../utils/logger";

const Navbar = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
}) => {
  const { onOpenSidenav, brandText } = props;
  const { isDark, toggleTheme } = useTheme();
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate("/auth/sign-in");
    } catch (error) {
      logger.error("Logout error:", error);
    }
  };

  const handleViewProfile = (closeDropdown: () => void) => {
    if (user?.id) {
      closeDropdown();
      navigate(`/admin/users/${user.id}`);
    }
  };

  const getDisplayName = () => {
    if (user?.first_name) {
      return user.first_name;
    }
    if (user?.email) {
      return user.email.split("@")[0];
    }
    return "Admin";
  };

  return (
    <nav className="sticky top-4 z-40 flex min-h-[97px] flex-col-reverse flex-wrap items-start justify-between gap-3 rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d] md:flex-row md:items-center">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-full flex-grow-0 items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[200px] xl:w-[130px]">
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* start Notification */}
        {/* <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          animation="origin-center md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="pointer-events-auto w-screen md:w-[360px] sm:w-[460px] max-w-none md:max-w-[360px] flex flex-col gap-3 rounded-none md:rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Notification
                </p>
                <p className="text-sm font-bold text-navy-700 dark:text-white">
                  Mark all read
                </p>
              </div>

              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-biafit-primary to-biafit-primary py-4 text-2xl text-white">
                  <BsArrowBarUp />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    New User Registration
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                    A new user has been added to your BiaFit platform!
                  </p>
                </div>
              </button>

              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-biafit-primary to-biafit-primary py-4 text-2xl text-white">
                  <BsArrowBarUp />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    System Update: BiaFit Dashboard
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                    Your fitness management system has been updated successfully!
                  </p>
                </div>
              </button>
            </div>
          }
          classNames={"inset-0 md:inset-auto w-full flex justify-center items-start pt-16 md:pt-0 md:top-4 md:-left-[440px]"}
          fixedOnMobile
        /> */}
        <div className="cursor-pointer text-gray-600" onClick={toggleTheme}>
          {isDark ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            user?.profile_image?.full_path ? (
              <img
                className="h-10 w-10 rounded-full object-cover"
                src={user.profile_image.full_path}
                alt={
                  user?.first_name
                    ? `${user.first_name} ${user.last_name || ""}`.trim()
                    : "Admin"
                }
              />
            ) : (
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-biafit-primary text-white">
                <MdPerson className="h-5 w-5" />
              </div>
            )
          }
          children={(closeDropdown: () => void) => (
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat py-3 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="ml-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    Hey, {getDisplayName()}
                  </p>
                </div>
              </div>
              <div className="mt-3 h-px w-full bg-gray-200 dark:bg-white/20" />

              <div className="ml-4 mt-3 flex flex-col gap-2">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewProfile(closeDropdown);
                  }}
                  className="flex items-center gap-2 text-left text-sm font-medium text-navy-700 dark:text-white"
                >
                  <FaUser className="h-4 w-5" />
                  <span>My Profile</span>
                </button>
                <button
                  onClick={handleLogout}
                  className="mt-3 flex items-center gap-2 text-left text-sm font-medium text-red-500"
                >
                  <MdLogout className="h-5 w-5" />
                  <span>Log Out</span>
                </button>
              </div>
            </div>
          )}
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
